import React, { useState } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaPlus, FaSave } from 'react-icons/fa';
import { ImCancelCircle } from 'react-icons/im';
import api from '../../services/api';
import ReactSelect from '../../components/ReactSelect';
import { FinField, FinNumber } from '../../components/FinField';
import { moeda } from '../../util/util';
import { toast } from 'react-toastify';
import { Redirect } from 'react-router-dom';
import '../../css/financeiro-parcela-pagar.css';

export default function SolicitarGasto() {
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem('empresa');
    const perfil = localStorage.getItem('perfil');
    const acessoNegado = ['rsvp', 'operadorrsvp', 'listarsvp'].includes(perfil);
    const [dados, setDados] = useState({
        fornecedor: null,
        itens: [{ produto: null, quantidade: 1, valorUnitario: '' }],
        enviando: false,
    });

    const enviar = async () => {
        if (!dados.fornecedor?.value) {
            toast.error('Selecione o fornecedor');
            return;
        }
        const itensValidos = (dados.itens || []).filter(it =>
            it.produto?.value &&
            Number(it.quantidade || 0) > 0 &&
            Number(it.valorUnitario || 0) >= 0
        );
        if (itensValidos.length === 0) {
            toast.error('Adicione ao menos 1 item válido');
            return;
        }

        setDados(prev => ({ ...prev, enviando: true }));
        try {
            const payload = {
                empresa: empresa,
                fornecedor_id: dados.fornecedor.value,
                itens: itensValidos.map(it => ({
                    produto_id: it.produto.value,
                    quantidade: Number(it.quantidade || 0),
                    valor_unitario: Number(it.valorUnitario || 0),
                })),
            };
            const resp = await api({
                method: 'post',
                action: '/evento/solicitarGasto',
                token: token,
                data: payload,
            });
            toast.success(resp.data?.msg || 'Pedido de gasto enviado');
            setDados({
                fornecedor: null,
                itens: [{ produto: null, quantidade: 1, valorUnitario: '' }],
                enviando: false,
            });
        } catch (e) {
            toast.error(e.response?.data?.error || 'Erro ao enviar pedido de gasto');
        } finally {
            setDados(prev => ({ ...prev, enviando: false }));
        }
    };

    const totalGeral = (dados.itens || []).reduce((acc, it) => {
        const qt = Number(it.quantidade || 0);
        const un = Number(it.valorUnitario || 0);
        if (isNaN(qt) || isNaN(un)) return acc;
        return acc + qt * un;
    }, 0);

    const adicionarItem = () => {
        setDados(prev => ({
            ...prev,
            itens: [...(prev.itens || []), { produto: null, quantidade: 1, valorUnitario: '' }],
        }));
    };

    const removerItem = (idx) => {
        setDados(prev => {
            const next = [...(prev.itens || [])];
            next.splice(idx, 1);
            return {
                ...prev,
                itens: next.length > 0 ? next : [{ produto: null, quantidade: 1, valorUnitario: '' }],
            };
        });
    };

    const atualizarItem = (idx, campo, valor) => {
        setDados(prev => {
            const next = [...(prev.itens || [])];
            next[idx] = { ...next[idx], [campo]: valor };
            return { ...prev, itens: next };
        });
    };

    if (acessoNegado) {
        return <Redirect to="/evento" />;
    }

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Solicitar gasto</h1>
                        <p className="fin-pp__subtitle">
                            {dados.fornecedor?.label || 'Monte a solicitacao e envie para o financeiro'}
                        </p>
                    </div>
                    <div className="fin-pp__actions">
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--pill"
                            onClick={adicionarItem}
                        >
                            <FaPlus size={13} /> Adicionar item
                        </button>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill"
                            disabled={dados.enviando}
                            onClick={enviar}
                        >
                            <FaSave size={13} /> {dados.enviando ? 'Enviando...' : 'Enviar pedido'}
                        </button>
                    </div>
                </div>
                <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                    <div className="fin-pp__filters">
                        <FinField label="Fornecedor" full>
                            <ReactSelect
                                value={dados.fornecedor}
                                onChange={(e) => setDados(prev => ({ ...prev, fornecedor: e }))}
                                placeholder="Buscar fornecedor..."
                                loadOptions={(input) => {
                                    return api({
                                        method: 'get',
                                        action: '/participante',
                                        token: token,
                                        params: {
                                            nome: input,
                                            tipoCadastro: ['orcamento', 'hotel'],
                                        },
                                    })
                                        .then(response => {
                                            const list = response.data.data || [];
                                            return list.map(reg => {
                                                const label = `${reg.codigo ?? ''} - ${reg.nome ?? ''}${reg.nomefantasia ? ' - ' + reg.nomefantasia : ''}${reg.cnpj ? ' (' + reg.cnpj + ')' : ''}${reg.cpf ? ' (' + reg.cpf + ')' : ''}`;
                                                return { value: reg.id, label };
                                            });
                                        })
                                        .catch(() => []);
                                }}
                            />
                        </FinField>
                    </div>
                </div>

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div style={{ padding: '16px 16px 10px' }}>
                        <div className="fin-pp__cphead">
                            <div style={{ minWidth: 0, flex: 1 }}>
                                <h3 className="fin-pp__cphead-title">Itens da solicitacao</h3>
                                <p className="fin-pp__cphead-sub">
                                    Informe produto, quantidade e preco unitario para cada linha.
                                </p>
                            </div>
                            <span className="fin-pp__pill is-info">{(dados.itens || []).length} item(ns)</span>
                        </div>
                    </div>

                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ minWidth: 960, tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 72 }}>Acao</th>
                                    <th>Produto</th>
                                    <th style={{ width: 150, textAlign: 'right' }}>Qtde</th>
                                    <th style={{ width: 180, textAlign: 'right' }}>Preco unit.</th>
                                    <th style={{ width: 180, textAlign: 'right' }}>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(dados.itens || []).length === 0 ? (
                                    <tr>
                                        <td colSpan={5} className="fin-pp__empty">Nenhum item informado.</td>
                                    </tr>
                                ) : (
                                    (dados.itens || []).map((item, idx) => {
                                        const qtde = Number(item.quantidade || 0);
                                        const unit = Number(item.valorUnitario || 0);
                                        const total = (isNaN(qtde) || isNaN(unit)) ? 0 : qtde * unit;
                                        return (
                                            <tr key={idx}>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost"
                                                        title="Remover item"
                                                        onClick={() => removerItem(idx)}
                                                    >
                                                        <ImCancelCircle size={14} />
                                                    </button>
                                                </td>
                                                <td style={{ minWidth: 280 }}>
                                                    <ReactSelect
                                                        value={item.produto}
                                                        onChange={(e) => atualizarItem(idx, 'produto', e)}
                                                        placeholder="Produto..."
                                                        defaultOptions
                                                        loadOptions={(input) => {
                                                            return api({
                                                                method: 'get',
                                                                action: '/produto',
                                                                token: token,
                                                                params: { nome: input, situacaoRegistro: 'ativo' },
                                                            })
                                                                .then(response => (response.data.data || []).map(reg => ({
                                                                    value: reg.id,
                                                                    label: `${reg.codigo ? reg.codigo + ' - ' : ''}${reg.nome ?? ''}`,
                                                                })))
                                                                .catch(() => []);
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <FinNumber
                                                        value={item.quantidade ?? ''}
                                                        allowNegative={false}
                                                        decimalScale={2}
                                                        onValueChange={(values) => atualizarItem(idx, 'quantidade', values.floatValue ?? '')}
                                                        style={{ paddingLeft: 14, textAlign: 'right' }}
                                                    />
                                                </td>
                                                <td>
                                                    <FinNumber
                                                        value={item.valorUnitario ?? ''}
                                                        allowNegative={false}
                                                        decimalScale={2}
                                                        onValueChange={(values) => atualizarItem(idx, 'valorUnitario', values.floatValue ?? '')}
                                                        style={{ paddingLeft: 14, textAlign: 'right' }}
                                                    />
                                                </td>
                                                <td style={{ textAlign: 'right' }}>
                                                    <span className="fin-pp__cell-strong">{moeda(total)}</span>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 12,
                        flexWrap: 'wrap',
                        padding: 16,
                        borderTop: '1px solid var(--fin-bd)',
                        background: 'var(--fin-sf)',
                    }}>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--sm"
                            onClick={adicionarItem}
                        >
                            <FaPlus size={13} /> Adicionar item
                        </button>
                        <div style={{ marginLeft: 'auto', textAlign: 'right' }}>
                            <div className="fin-pp__cell-muted">Total geral</div>
                            <div className="fin-pp__cell-strong" style={{ fontSize: 18 }}>
                                {moeda(totalGeral)}
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                    <button
                        type="button"
                        className="fin-pp__btn fin-pp__btn--primary"
                        disabled={dados.enviando}
                        onClick={enviar}
                    >
                        <FaSave size={13} /> {dados.enviando ? 'Enviando...' : 'Enviar pedido'}
                    </button>
                </div>
            </div>
        </ErpTemplate>
    );
}
